import React from 'react';
import clsx from 'clsx';
import dayjs from '../../../utils/date';
import { T } from '../../../utils/I18n/I18n'
import readConfig from '../../../utils/readClientConfiguration';
import productionConfiguration from '../../../config/default.json';
import './ProductPromo.scss';

const dateFormat = readConfig(productionConfiguration, 'dateFormat');

const ProductPromoDescription = ({ promoPercentage, promotionStart, promotionEnd, promoText, type, isCms }) => {
  const prettyPromotionStart = dayjs(promotionStart).format(dateFormat);
  const prettyPromotionEnd = dayjs(promotionEnd).format(dateFormat);
  const mainClass = 'promo_description';

  return (
    <div
      className={clsx(
        'promo_description',
        isCms && 'promo_description-slider',
        type === 'promo' && `clearance-promo`,
        type === 'club' && 'promo_description__club',
      )}
    >
      <div className={clsx(`${mainClass}__primary`, isCms && `${mainClass}__primary-slider`)}>
        {type === 'club' && (
          <span className={`${mainClass}__primary-desc`}>
            <T id="club.clubPromoTooltip" />
            <br/>
            <b>
              <T id="club.clubPromoTooltipAction" />
            </b>
          </span>
        )}
        <br/>
        <span className={clsx(`${mainClass}__primary-desc`, type === 'club' && `${mainClass}__primary-desc_club`)}>
          {!promotionStart ? (
            <T id="product.promoDescriptionExpires" />
          ) : (
            <T id="product.promoDescription" promoStart={prettyPromotionStart} promoEnd={prettyPromotionEnd} />
          )}
        </span>
      </div>
    </div>
  );
};

export default ProductPromoDescription;
